import React from 'react';
// import './Cell.css';
import styled from 'styled-components';

const CellGroup = styled.div`
    display: grid;
    grid-template-columns: 60px auto;
    grid-gap: 25px;
    align-items: center;
    min-width: 320px;
`

const CellImage = styled.div`
    width: 60px;
    height: 60px;
    background: #212C4F;
    border-radius: 10px;
    background-image: url(${props => props.image});
    background-size: 60px;
`

const CellTitle = styled.div`
    color: #CBDCFD;
    font-size: 22px;
    border-bottom: 1px solid rgba(255,255,255, 0.1);
    padding: 30px 0;
`

const Cell = props => (
    <CellGroup>
        <CellImage image={props.image}></CellImage>
        <CellTitle>{props.title}</CellTitle>
    </CellGroup>
)

// class Cell extends React.Component {

//     constructor(props){
//         super(props);
//     };

//     render() {
//         return (
//             <div className="Cell">
//                 <div className="CellGroup">
//                     <img src={this.props.image} />
//                     <p>{this.props.title}</p>
//                 </div>
//             </div>
//         )
//     }
// }

export default Cell


// WEBPACK FOOTER //
// ./src/components/Cell.js